import Utils from '@/scripts/Utils';
import store from '@/store/index';

const createLabels = (startDate, endDate, mode) => {
    let labels = []
    let dates = []
    switch (mode) {
      case 'day':
        dates = Utils.generateDaysByInterval(startDate, endDate)
        labels = dates.map((date) => ({date, liters: 0, label: Utils.formatDate(date, '<dd>/<MM>')}))
      break;
      case 'month':
        dates = Utils.generateMonthsByInterval(startDate, endDate)
        labels = dates.map((date) => ({date, liters: 0, label: Utils.formatMonthDate(date, '<MM>/<YY>')}))
      break;
      case 'hour':
        dates = Utils.generateHoursByInterval(startDate, endDate)
        labels = dates.map((date) => ({date, liters: 0, label: Utils.formatDate(date, '<hh>:<mm>')}))
      break;
    }
    return labels;
}

const checkPeriod = (labels, mode) => {

    let permittedStartDate = null;
    let permittedEndDate = null;
    switch (mode) {
      case 'day':
        if (labels.length > 90) {
          permittedStartDate = labels[0].label
          permittedEndDate = labels[89].label
        }
      break;
      case 'hour':
        if (labels.length > 24) {
          permittedStartDate = labels[0].label
          permittedEndDate = labels[23].label
        }
      break;
      case 'month':
        if (labels.length > 12) {
          permittedStartDate = labels[0].label
          permittedEndDate = labels[11].label
        }
      break;
    }
    return {
        permittedStartDate,
        permittedEndDate
    }
}

const createDataset = (resumeGoal, goalConsumptionValue = null) => {
  try {
    const { goal, ...resume } = resumeGoal;
    const unitMeasure = store.getters.unitMeasure;
    const metaValue = (typeof goal !== 'undefined' && goal !== null) ? goal : 0;
    let readingList = Object.values(resume)
    let modemIds = Object.keys(resume)
    let readings = []
    
    readingList.forEach(
      (reading, index) => {
        // Verificar se reading existe e tem a propriedade readings
        if (!reading || !reading.readings || !Array.isArray(reading.readings)) {
          return; // Pular este item
        }
        let datasets = []
        const now = new Date();
        const readingsLength = reading.readings.length;
        const backgroundColors = [];
        if (reading.labels && Array.isArray(reading.labels)) {   
          for (let i = 0; i < readingsLength; i++) {
            backgroundColors.push(reading.readings[i].date > now ? "#E0EFFF" : "#87B9FD");   
          } 
        } else {
          for (let i = 0; i < readingsLength; i++) {
            backgroundColors.push("#87B9FD");
          }
        }

        if (metaValue === 0) {
          // Apenas um dataset: Consumo de água
          const dataWater = [];
          for (let i = 0; i < readingsLength; i++) {
            const item = reading.readings[i];
            const value = unitMeasure === 'liters' ? (Number(item.water) * 1000) : Number(item.water);
            dataWater.push(value.toFixed(2));
          }

          const waterDataset = {
            average: reading.average.toFixed(2),
            averageRaw: reading.average, // Manter valor completo para cálculos precisos no plugin
            unitMeasure: unitMeasure,
            label: "Consumo de água",
            data: dataWater,
            backgroundColor: backgroundColors,
            borderWidth: 2,
            order: 1,
            stack: 'Stack 0',
            type: "bar"
          };
          
          // Adicionar meta de consumo se disponível
          if (goalConsumptionValue !== null && goalConsumptionValue !== undefined && !isNaN(goalConsumptionValue)) {
            waterDataset.goalConsumption = parseFloat(goalConsumptionValue.toFixed(2));
          }
          
          datasets.push(waterDataset);
        } else {
          // Dois datasets: Medido até a meta e Acima da meta
          const dataUpToGoal = [];
          const dataAboveGoal = [];
          
          for (let i = 0; i < readingsLength; i++) {
            const item = reading.readings[i];
            const value = unitMeasure === 'liters' ? Number(item.water) * 1000 : Number(item.water);
            
            if (value <= metaValue) {
              dataUpToGoal.push(value.toFixed(2));
              dataAboveGoal.push(0);
            } else {
              dataUpToGoal.push(metaValue);
              dataAboveGoal.push((value - metaValue).toFixed(2));
            }
          }
          
          const upToGoalDataset = {
            label: "Medido até a meta",
            data: dataUpToGoal,
            backgroundColor: backgroundColors,
            borderWidth: 2,
            order: 1,
            stack: 'Stack 0',
            type: "bar",
            unitMeasure: unitMeasure
          };
          
          // Adicionar meta de consumo se disponível
          if (goalConsumptionValue !== null && goalConsumptionValue !== undefined && !isNaN(goalConsumptionValue)) {
            upToGoalDataset.goalConsumption = parseFloat(goalConsumptionValue.toFixed(2));
          }
          
          datasets.push(upToGoalDataset);
          datasets.push({
            label: "Acima da meta",
            data: dataAboveGoal,
            backgroundColor: "#4092FF",
            borderWidth: 2,
            order: 1,
            stack: 'Stack 0',
          });
        }
        
        readings.push({
          labels: reading.labels || [],
          datasets,
          modemId: modemIds[index]
        });
      }
    )
    return readings;
  } catch (error) {
    console.error('Erro em createDataset:', error)
    return []
  }
}

const createDataTable = (resume) => {
    let readings_table = []
    let readingList = Object.values(resume)
    let modemIds = Object.keys(resume)
    readingList.forEach(
      (reading, index) => {
        let items = []
        items = reading.readings.filter((item) => !item.isEstimative).map((item) => ({date: item.label, value: item.water.toFixed(2)}))
        readings_table.push({
          items,
          modemId: modemIds[index]
        })
      }
    )
    return readings_table;
}

export default {
    createLabels,
    checkPeriod,
    createDataset,
    createDataTable,
}
